import rest from './data/restWrapper';
import useStore from './data/state/zustand';

export const registerPushSW = async () => {
  if (!('serviceWorker' in navigator)) {
    console.warn('Service Workers not supported');
    return;
  }

  try {
    // čisti sve koji nisu push-sw.js
    const allRegistrations = await navigator.serviceWorker.getRegistrations();
    for (const reg of allRegistrations) {
      const script = reg?.active?.scriptURL || '';
      if (script && !script.includes('push-sw.js')) {
        const success = await reg.unregister();
        console.log(success ? `Unregistered: ${script}` : `⚠️ Failed to unregister: ${script}`);
      } else {
        console.log(`adržavam: ${script}`);
      }
    }

    // Registriraj novi SW za /
    const reg = await navigator.serviceWorker.register('/push-sw.js', { scope: '/' });
    // console.log('Service Worker registered:', reg);

    // Push pretplata
    const subscription = await reg.pushManager.getSubscription();
    if (!subscription) {
      await requestPushPermission(reg);
    } else {
      const role = useStore.getState().authTokenInfo?.user?.role;
      const uuid = useStore.getState().authTokenInfo?.user?.uuid;
      if (role && uuid) {
        const isValid = await rest('/getValidSubscription', 'POST', { subscription, role, uuid });
        if (!isValid) {
          await subscription.unsubscribe();
          await requestPushPermission(reg);
        }
      }
    }
  } catch (error) {
    console.error('Greška pri registraciji SW:', error);
  }
};

const requestPushPermission = async (reg: ServiceWorkerRegistration) => {
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    console.warn('Push permission not granted');
    return;
  }

  const publicKey = await rest('/getPublicVapidKey');
  // console.log(' VAPID key fetched');

  const subscription = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(publicKey.publicVapidKey),
  });

  const role = useStore.getState().authTokenInfo?.user?.role;
  const uuid = useStore.getState().authTokenInfo?.user?.uuid;
  if (role && uuid) {
    await rest('/subscribeToPushNotifications', 'POST', { subscription, role, uuid });
    console.log('Push subscription saved');
  }
};

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);

  const output = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    output[i] = rawData.charCodeAt(i);
  }

  return output;
}
